<template><ProductDetailBase route-key="/products/new-energy" /></template>
<script>
import ProductDetailBase from "./ProductDetailBase.vue";
export default { name: "NewEnergyPage", components: { ProductDetailBase } };
</script>
